<script setup lang="ts">
import { nextTick, onMounted, computed } from 'vue';
import { useUserAgentState } from '~/composables/useUserAgentState';

defineProps<{
  adSpotId: string;
}>();

const { isFromNavel, isFromSp } = useUserAgentState();

const isDisplayable = computed(() => {
  return !isFromNavel.value && isFromSp.value;
});

onMounted(async () => {
  await nextTick();

  // NOTE: 外部JSの仕組み的にもUAを見て有効化するかどうかを判定しているようなので、レスポンシブなどは考慮しない
  if (isDisplayable.value && window.RFP) {
    window.RFP.InFeed.Default.run();
  }
});
</script>

<template>
  <ClientOnly>
    <aside v-if="isDisplayable" class="md:hidden">
      <div :data-rfp-adspot-id="adSpotId" class="hidden" />
    </aside>
  </ClientOnly>
</template>
